module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGab43d331888b46c6f56c2304d35fc475.ab43d331.png";